import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";
import axiosCancel from 'axios-cancel';
import { each, merge } from "lodash";
import FileSaver from 'file-saver';
import { storageHelper } from "./tools/tools.js";

axiosCancel(axios, {
    debug: (process.env.NODE_ENV === 'development')
});

let input = document.querySelectorAll("#xsrf input")[0];
axios.defaults.headers.common['X-XSRF-Token-App'] = input !== undefined ? input.value : 'none';

Vue.use(Vuex);

const storeSearch = new Vuex.Store({
    state: {
        search: null,
        searchCombi: null,
        searchEffectTargets: null,
        searchDetails: null,
        searchDetailsLoaded: false,
        searchFilter: null,
        searchFilterDefaults: null,
        searchFilterSimple: null,
        searching: false,
        study: null,
        searchFilterDirty: false,
        studyLoaded: false,
        studySearchFilter: { searchText: "" },
        studySearch: null,
        positiveOnly: false,
        labels: { },
        expandCombiTable: false
    },
    getters: { },
    actions: {
        getLabels: ({ state, commit }, data) => {
            if (typeof state.labels[data.label] === 'undefined') {
                getFromApi("/api/labels", data).then((value) => {
                    var labels = { [data.label]: value }
                    commit("LABELS", labels);
                });
            }
        },
        getSearchFilter: ({ commit }) => {
            getFromApi("/api/jobeffects/search/searchfilter", null, true).then((value) => {
                commit("SEARCHFILTER", value);
            });
        },
        getSearchFilterSimple: ({ commit }) => {
            getFromApi("/api/jobeffects/search/simplesearchfilter").then((value) => {
                commit("SEARCHFILTERSIMPLE", value);
            });
        },
        getSearchFilterWithParams: ({ commit }, data) => {
            var idString = (typeof data === 'object') ? data.join("&id=") : data;
            var paramsString = "?cultureCode=" + culture().cultureCode + "&id=" + idString;
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/jobeffects/search/searchfilter" + paramsString)
                    .then(result => {
                        commit("SEARCHFILTER", result.data.value);
                        resolve(true);
                    })
                    .catch(error => {
                        console.warn(error);
                        reject(error);
                        showGenericError();
                    });
            });
        },
        getSearchDetails: ({ commit }, data) => {
            commit("SEARCHDETAILSLOADED", false);
            getFromApi("/api/jobeffects/result", data, true).then((value) => {
                commit("SEARCHDETAILS", value);
                commit("SEARCHDETAILSLOADED", true);
            });
        },
        search: ({ commit }, data) => {
            commit("SEARCHING", true);
            postToApi("/api/jobeffects/search/defaultsearch", data, true, 'defaultSearch').then((value) => {
                commit("SEARCH", value);
                commit("SEARCHING", false);
                commit("SEARCHFILTERDIRTY", false);
                commit("SEARCHEFFECTTARGETS", null);
            });
        },
        searchCombi: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                postToApi("/api/jobeffects/search/combinationactivitysearch", data, true).then((value) => {
                    commit("SEARCHCOMBI", value);
                    resolve(true);
                });
            });
        },
        searchEffectTargets: ({ commit }, data) => {
            getFromApi("/api/jobeffects/search/effecttargetsearch", data.params, true).then((value) => {
                commit("SEARCHEFFECTTARGETS", { id: data.id, value: value });
            });
        },
        getStudy: ({ commit }, id) => {
            commit("STUDYLOADED", false);
            return new Promise((resolve, reject) => {
                getFromApi("/api/study/" + id).then((value) => {
                    commit("STUDY", value);
                    commit("STUDYLOADED", true);
                    resolve(true);
                });
            });
        },
        saveStudyToMyPage: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios
                    .put("/api/mypages/mylibrary/saved-studies", data, { params: culture() })
                    .then(result => {
                        if (result.data.success) {
                            resolve(true);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        save: ({ commit }, data) => {
            // type = 'search-criterias' || 'jobeffect-results'
            var url = "/api/mypages/mylibrary/saved-" + data.type;
            delete data.type;
            return new Promise((resolve, reject) => {
                axios
                    .put(url, data, { params: culture() })
                    .then(result => {
                        if (result.data.success) {
                            resolve(true);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        console.warn(error);
                        reject(error);
                    });
            });
        },
        export: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/jobeffects/result/excel', { params: merge(data, culture()), responseType: 'blob' })
                    .then((response) => {
                        FileSaver.saveAs(response.data, 'Jobeffekt.xlsx');
                        resolve(true);
                    }).catch((error) => {
                        console.warn(error);
                        reject(error);
                    });
            });
        },
        getStudySearchFilter: ({ commit }) => {
            return new Promise((resolve, reject) => {
                getFromApi("/api/study/search/searchfilter").then((value) => {
                    commit("STUDYSEARCHFILTER", value);
                    resolve(value);
                })
            });
        },

        studySearchNewest: ({ commit }) => {
            commit("SEARCHING", true);
            getFromApi("/api/study/search/newest").then((value) => {
                commit("STUDYSEARCH", value);
                commit("SEARCHING", false);
            })
        },
        studySearch: ({ commit }, data) => {
            commit("SEARCHING", true);
            postToApi("/api/study/search", data, true).then((value) => {
                commit("STUDYSEARCH", value);
                commit("SEARCHING", false);
            });
        },
        studySearchExport: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios.post('/api/study/search/excel',data, {params: culture(),responseType: 'blob' })
                    .then((response) => {
                        FileSaver.saveAs(response.data, 'Studies.xlsx');
                        resolve(true);
                    }).catch((error) => {
                        console.warn(error);
                        reject(error);
                    });
            });
        },

        tip: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                postToApi("/api/emails/tip", data, true).then((value) => {
                    resolve(value.success);
                });
            });
        }
    },
    mutations: {
        SEARCHFILTER: (state, result) => {
            state.searchFilter = result;
        },
        SEARCHFILTERSIMPLE: (state, result) => {
            each(result.activities, (item) => { item.selected = false; })
            each(result.targetgroups, (item) => { item.selected = false; })
            state.searchFilterSimple = result;
        },
        SEARCHDETAILS: (state, result) => {
            state.searchDetails = result;
        },
        SEARCHDETAILSLOADED: (state, result) => {
            state.searchDetailsLoaded = result;
        },
        SEARCH: (state, result) => {
            if (result !== null) {
                each(result.jobeffectViewModels, (effect, i) => {
                    effect.open = false;
                    effect.id = "id" + i;
                });
            }

            state.search = result;
            state.searchCombi = null;
        },
        SEARCHCOMBI: (state, result) => {
            each(result.jobeffectViewModels, (effect, i) => {
                effect.open = false;
                effect.id = "combiId" + i;
            });
            state.searchCombi = result;
        },
        SEARCHEFFECTTARGETS: (state, result) => {
            if (result === null) {
                state.searchEffectTargets = null;
            } else {
                let _val = { [result.id]: result.value }
                state.searchEffectTargets = Object.assign({}, state.searchEffectTargets, _val);
            }
        },
        SEARCHING: (state, result) => {
            state.searching = result;
        },
        STUDY: (state, result) => {
            each(result.results, item => {
                item.open = false;
            });
            state.study = result;
        },
        STUDYLOADED: (state, result) => {
            state.studyLoaded = result;
        },
        SEARCHFILTERDIRTY: (state, val) => {
            state.searchFilterDirty = val;
        },
        STUDYSEARCHFILTER: (state, result) => {
            // published in journal options has no id initially
            each(result.publishedInScientificJournal.options, (option) => { option.id = option.name; });
            each(result, item => {
                if (item !== null) item.selected = 'all';
            });
            state.studySearchFilter = result;
        },
        STUDYSEARCH: (state, result) => {
            state.studySearch = result;
        },
        POSITIVEONLY: (state, result) => {
            let value = (result || result === "true");
            state.positiveOnly = value;
        },
        LABELS: (state, result) => {
            var labelClone = Object.create(state.labels);
            var key = Object.keys(result)[0];
            labelClone[key] = result[key];
            state.labels = labelClone;
        },
        EXPANDCOMBITABLE: (state, value) => {
            state.expandCombiTable = value;
        }
    }
});

const storeMyPages = new Vuex.Store({
    state: {
        createStudyVm: null,
        suggestStudyVm: null,
        myStudies: null,
        myStudiesMember: null,
        studyOverview: null,
        studyOverviewResearchers: null,
        savedStudies: null,
        savedJobeffectResults: null,
        savedSearchCriterias: null,
        savedAgent: null,
        labels: { },
        comments: null,
        studySource: null,
        journals: null
    },
    getters: { },
    actions: {
        delete: ({ commit }, data) => {
            // type = 'studies' || 'search-criterias' || 'jobeffect-results'
            var url = "/api/mypages/mylibrary/saved-" + data.type;
            delete data.type;
            return new Promise((resolve, reject) => {
                axios
                    .delete(url, { params: merge(data, culture()) })
                    .then(result => {
                        if (result.data.success) {
                            resolve(true);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        console.warn(error);
                        reject(error);
                    });
            });
        },
        getCreateStudyVm: ({ commit }, data) => {
            getFromApi("/api/study/create/studyfilter", data).then((value) => {
                if (value.url === null || value.url === "") storeMyPages.dispatch('getStudyFile', { id: value.id })
                commit("CREATESTUDYVM", value);
            })
        },
        getStudyFile: ({ commit }, data) => {
            getFromApi("/api/study/has-file", data).then((value) => {
                commit('STUDYSOURCE', value);
            })
        },
        getSuggestStudyVm: ({ commit }, data) => {
            getFromApi("/api/study/create-submitted/studyfilter", data).then((value) => {
                commit("SUGGESTSTUDYVM", value);
            })
        },
        getCreateStudyResult: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                getFromApi("/api/study/create/studyresultfilter", data).then((value) => {
                    resolve(value);
                })
            })
        },
        getComments: ({ commit }, data) => {
            getFromApi("/api/study/create/comments", data).then((value) => {
                commit('COMMENTS', value)
            })
        },
        postComment: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                postToApi("/api/study/create/comments", data).then((value) => {
                    resolve(value);
                })
            })
        },
        saveStudy: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                postToApi("/api/study/create", data, true).then((value) => {
                    resolve(value);
                })
            })
        },
        suggestStudy: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                var formData = new FormData();
                formData.append('createStudyViewModel', JSON.stringify(data.vm));
                formData.append('cultureCode', culture()['cultureCode']);

                if (data.file !== null) formData.append('file', data.file, data.file.name);

                axios({
                    method: 'post',
                    url: "/api/study/create-submitted",
                    data: formData,
                    config: { headers: { 'Content-Type': 'multipart/form-data' } }
                })
                .then((result) => {
                    if (result.data.success) {
                        resolve(true);
                    } else {
                        console.warn(result.data.exception.Message);
                        reject(result);
                        showGenericError();
                    }
                }).catch((error) => {
                    console.warn(error);
                    reject(error);
                    showGenericError();
                })
            })
        },
        getMyStudies: ({ commit }) => {
            axios
                .all([
                    axios.get("/api/mypages/mystudies/in-progress", { params: culture() }),
                    axios.get("/api/mypages/mystudies/ready-for-approval", { params: culture() }),
                    axios.get("/api/mypages/mystudies/i-can-comment", { params: culture() }),
                ])
                .then(
                    axios.spread((ipResult, rfaResult, iccResult) => {
                        commit("MYSTUDIES", {
                            ip: ipResult.data.value,
                            rfa: rfaResult.data.value,
                            icc: iccResult.data.value
                        });
                    })
                )
                .catch(error => {
                    console.warn(error);
                });
        },
        getMyStudiesMember: ({ commit }) => {
            getFromApi("/api/mypages/mystudies/my-submitted-studies").then((value) => {
                commit("MYSTUDIESMEMBER", value);
            })
        },
        getStudyOverviewResearchers: ({ commit }) => {
            getFromApi("/api/mypages/studyoverview/researcher").then((value) => {
                commit("STUDYOVERVIEWRESEARCHERS", value);
            })
        },
        getStudyOverview: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                getFromApi("/api/mypages/studyoverview/name", data).then((value) => {
                    commit("STUDYOVERVIEW", value);
                    resolve(true);
                })
            });
        },
        getSavedStudies: ({ commit }) => {
            getFromApi("/api/mypages/mylibrary/saved-studies").then((value) => {
                commit("SAVEDSTUDY", value);
            });
        },
        getSavedJobeffectResults: ({ commit }) => {
            getFromApi("/api/mypages/mylibrary/saved-jobeffect-results").then((value) => {
                commit("SAVEDJOBEFFECTRESULTS", value);
            });
        },
        getSavedJSearchCriterias: ({ commit }) => {
            getFromApi("/api/mypages/mylibrary/saved-search-criterias").then((value) => {
                commit("SAVEDSEARCHCRITERIAS", value);
            });
        },
        getSavedAgent: ({ commit }) => {
            getFromApi("/api/mypages/mylibrary/studyagent/studyagentfilter").then((value) => {
                commit("SAVEDAGENT", value);
            });
        },
        updateSavedAgent: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                postToApi("/api/mypages/mylibrary/studyagent", data).then((value) => {
                    resolve(true);
                });
            });
        },
        downloadStudy: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/study/file', { params: merge(data, culture()), responseType: 'blob' })
                    .then((response) => {
                        FileSaver.saveAs(response.data, data.name);
                        resolve(true);
                    }).catch((error) => {
                        console.warn(error);
                        reject(error);
                    });
            });
        },
        getLabels: ({ state, commit }, data) => {
            if (typeof state.labels[data.label] === 'undefined') {
                getFromApi("/api/labels", data).then((value) => {
                    var labels = { [data.label]: value }
                    commit("LABELS", labels);
                });
            }
        },
        sendToApproval: ({ commit }, data) => {
            var url = "/api/study/create/send-to-approval?studyId=" + data.studyId;
            return new Promise((resolve, reject) => {
                postToApi(url).then((value) => {
                    resolve(value);
                });
            });
        },
        disableStudy: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                getFromApi('/api/study/create/send-to-disabled', data).then((value) => {
                    resolve(value);
                });
            });
        },
        tip: ({ commit }, data) => {
            return new Promise((resolve, reject) => {
                postToApi("/api/emails/tip", data, true).then((value) => {
                    resolve(value.success);
                });
            });
        },
        getJournals: ({ commit }) => {
            return new Promise((resolve, reject) => {
                getFromApi("/api/study/create/journals").then((value) => {
                    commit("JOURNALS", value);
                    resolve(value);
                })
            });
        }
    },
    mutations: {
        CREATESTUDYVM: (state, result) => {
            if (result !== null && result.isNew) {
                result.publishedInScientificJournal = undefined;
                // We set the vm to not be new any more, since we have changed the state of publishedInScientificJournal.
                // This is due to fact that we want to avoid resetting publishedInScientificJournal when ever a new studyResult is created removed and we are working on a new study.
                result.isNew = false;
            }
            state.createStudyVm = result;
        },
        SUGGESTSTUDYVM: (state, result) => {
            state.suggestStudyVm = result;
        },
        MYSTUDIES: (state, result) => {
            state.myStudies = result;
        },
        MYSTUDIESMEMBER: (state, result) => {
            state.myStudiesMember = result;
        },
        STUDYOVERVIEW: (state, result) => {
            // add extra props
            each(result, lev1Item => {
                lev1Item.open = false;
                each(lev1Item.items, lev2Item => {
                    lev2Item.open = false;
                });
            });
            state.studyOverview = result;
        },
        STUDYOVERVIEWRESEARCHERS: (state, result) => {
            state.studyOverviewResearchers = result;
        },
        SAVEDSTUDY: (state, result) => {
            state.savedStudies = result;
        },
        SAVEDJOBEFFECTRESULTS: (state, result) => {
            state.savedJobeffectResults = result;
        },
        SAVEDSEARCHCRITERIAS: (state, result) => {
            state.savedSearchCriterias = result;
        },
        SAVEDAGENT: (state, result) => {
            // add extra props
            each(result.searchActivities, lev1Item => {
                lev1Item.open = false;
            });
            each(result.searchTargetGroups, lev1Item => {
                lev1Item.open = false;
            });
            state.savedAgent = result;
        },
        LABELS: (state, result) => {
            var labelClone = Object.create(state.labels);
            var key = Object.keys(result)[0];
            labelClone[key] = result[key];
            state.labels = labelClone;
        },
        COMMENTS: (state, result) => {
            state.comments = result;
        },
        STUDYSOURCE: (state, result) => {
            state.studySource = result;
        },
        JOURNALS: (state, result) => {
            state.journals = result;
        }

    }
});

var metaNode = document.querySelector('meta[name="culture"]');

function culture() {
    return metaNode !== null ? { cultureCode: metaNode.content } : { cultureCode: "da-DK" };
}

function getFromApi(url, data, genericError) {
    var params = merge(culture(), data);
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params })
            .then((result) => {
                if (result.data.success !== undefined && !result.data.success) {
                    throw new Error(result.message);
                }
                resolve(result.data.value || result.data);
            }).catch((error) => {
                console.warn(error);
                reject(error);
                if (genericError) showGenericError();
            })
    })
}

function postToApi(url, data, genericError, requestId = false) {
    let requestConfig = {
        params: culture()
    }

    if (requestId) {
        requestConfig.requestId = requestId;
    }

    return new Promise((resolve, reject) => {
        axios.post(url, data, requestConfig)
            .then((result) => {
                if (result.data.success !== undefined && !result.data.success) {
                    throw new Error(result.message);
                }
                resolve(result.data.value || result.data);
            }).catch((error) => {
                if (axios.isCancel(error)) {
                    return false;
                }
                console.warn(error);
                reject(error);
                if (genericError) showGenericError();
            })
    })
}

function showGenericError() {
    var app = null;
    if (window.vm.hasOwnProperty('studySearchApp')) {
        app = window.vm.studySearchApp;
    } else if (window.vm.hasOwnProperty('jobEffectsApp')) {
        app = window.vm.jobEffectsApp;
    }

    if (app !== null) app.$modal.show('generic-error');
}

export { storeSearch, storeMyPages }



// WEBPACK FOOTER //
// ./src/store.js